import React, { useState, Component } from 'react';
import { RocketIcon, ExternalLinkIcon, SearchIcon, StarIcon, ClockIcon, BookOpenIcon, BarChart2Icon, ShieldCheckIcon, FileTextIcon, UsersIcon, BuildingIcon, CloudIcon, UserCogIcon, FolderIcon, GlobeIcon, CalculatorIcon, HeadphonesIcon, DatabaseIcon } from 'lucide-react';
interface Tool {
  id: number;
  name: string;
  description: string;
  category: string;
  icon: ComponentType<{
    size?: number;
    color?: string;
    strokeWidth?: number;
  }>;
  url: string;
  pinned: boolean;
  new?: boolean;
}
const tools: Tool[] = [{
  id: 1,
  name: 'Encompass LOS',
  description: 'Loan origination system — manage pipeline, docs, and disclosures',
  category: 'Core Systems',
  icon: BuildingIcon,
  url: '#',
  pinned: true
}, {
  id: 2,
  name: 'Salesforce CRM',
  description: 'Customer relationship management and lead tracking',
  category: 'Core Systems',
  icon: CloudIcon,
  url: '#',
  pinned: true
}, {
  id: 3,
  name: 'Rate Sheet Portal',
  description: 'Live pricing for conventional, FHA, VA, and USDA products',
  category: 'Rates & Pricing',
  icon: BarChart2Icon,
  url: '#',
  pinned: true,
  new: true
}, {
  id: 4,
  name: 'Compliance Hub',
  description: 'TRID, RESPA, and regulatory compliance resources',
  category: 'Compliance',
  icon: ShieldCheckIcon,
  url: '#',
  pinned: true
}, {
  id: 5,
  name: 'HR Portal',
  description: 'Benefits, PTO, payroll, and employee resources',
  category: 'HR & Admin',
  icon: UserCogIcon,
  url: '#',
  pinned: false
}, {
  id: 6,
  name: 'Shared Drive',
  description: 'Company documents, templates, and shared files',
  category: 'HR & Admin',
  icon: FolderIcon,
  url: '#',
  pinned: false
}, {
  id: 7,
  name: 'Learning Center',
  description: 'Training modules, CE hours, and certifications',
  category: 'Training',
  icon: BookOpenIcon,
  url: '#',
  pinned: false
}, {
  id: 8,
  name: 'Mortgage Calculator',
  description: 'Payment, affordability, and refinance calculators',
  category: 'Rates & Pricing',
  icon: CalculatorIcon,
  url: '#',
  pinned: false
}, {
  id: 9,
  name: 'Company Directory',
  description: 'Team contacts, org chart, and department listings',
  category: 'HR & Admin',
  icon: UsersIcon,
  url: '#',
  pinned: false
}, {
  id: 10,
  name: 'IT Help Desk',
  description: 'Submit tickets, track issues, and get tech support',
  category: 'IT & Support',
  icon: HeadphonesIcon,
  url: '#',
  pinned: false
}, {
  id: 11,
  name: 'Document Library',
  description: 'Loan forms, disclosures, and marketing materials',
  category: 'Documents',
  icon: FileTextIcon,
  url: '#',
  pinned: false
}, {
  id: 12,
  name: 'Market Data',
  description: 'MBS pricing, economic indicators, and rate trends',
  category: 'Rates & Pricing',
  icon: GlobeIcon,
  url: '#',
  pinned: false
}, {
  id: 13,
  name: 'Reporting Dashboard',
  description: 'Production reports, pipeline analytics, and KPIs',
  category: 'Core Systems',
  icon: DatabaseIcon,
  url: '#',
  pinned: false,
  new: true
}];
const categories = ['All', 'Core Systems', 'Rates & Pricing', 'Compliance', 'HR & Admin', 'Training', 'IT & Support', 'Documents'];
const recentlyUsed = [1, 3, 4, 2];
export function Launchpad() {
  const [search, setSearch] = useState('');
  const [activeCategory, setActiveCategory] = useState('All');
  const filtered = tools.filter(t => {
    const matchCat = activeCategory === 'All' || t.category === activeCategory;
    const matchSearch = t.name.toLowerCase().includes(search.toLowerCase()) || t.description.toLowerCase().includes(search.toLowerCase());
    return matchCat && matchSearch;
  });
  const pinned = filtered.filter(t => t.pinned);
  const unpinned = filtered.filter(t => !t.pinned);
  const recent = tools.filter(t => recentlyUsed.includes(t.id));
  return <div style={{
    maxWidth: 1280,
    margin: '0 auto'
  }} data-id="element-319">
      {/* Header */}
      <div style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      marginBottom: 24,
      flexWrap: 'wrap',
      gap: 12
    }} data-id="element-320">
        <div data-id="element-321">
          <h2 style={{
          fontSize: 26,
          fontWeight: 900,
          color: '#1A2B3C',
          margin: '0 0 3px',
          fontStyle: 'italic',
          letterSpacing: '-0.04em'
        }} data-id="element-322">
            Launchpad
          </h2>
          <p style={{
          fontSize: 13,
          color: '#5A6A8A',
          margin: 0
        }} data-id="element-323">
            Your gateway to every Swift tool and resource
          </p>
        </div>
        <div style={{
        position: 'relative'
      }} data-id="element-324">
          <SearchIcon size={14} style={{
          position: 'absolute',
          left: 10,
          top: '50%',
          transform: 'translateY(-50%)',
          color: '#A0AECB'
        }} data-id="element-325" />
          <input type="text" placeholder="Search tools..." value={search} onChange={e => setSearch(e.target.value)} style={{
          paddingLeft: 30,
          paddingRight: 12,
          paddingTop: 8,
          paddingBottom: 8,
          fontSize: 13,
          borderRadius: 8,
          border: '1.5px solid #E4EAF6',
          background: '#F4F8FC',
          color: '#1A2B3C',
          outline: 'none',
          width: 220
        }} onFocus={e => {
          e.target.style.borderColor = '#2B8DC4';
        }} onBlur={e => {
          e.target.style.borderColor = '#E4EAF6';
        }} data-id="element-326" />
        </div>
      </div>

      {/* Recently Used */}
      {!search && activeCategory === 'All' && <div style={{
      background: '#FFFFFF',
      borderRadius: 12,
      padding: '20px 22px',
      marginBottom: 20,
      border: '1px solid #E4EAF6',
      borderTopWidth: 3,
      borderTopColor: '#1A2B3C',
      boxShadow: '0 2px 8px rgba(13,27,42,0.06)'
    }} data-id="element-327">
          <div style={{
        display: 'flex',
        alignItems: 'center',
        gap: 8,
        marginBottom: 14
      }} data-id="element-328">
            <ClockIcon size={15} color="#2B8DC4" data-id="element-329" />
            <h3 style={{
          fontSize: 14,
          fontWeight: 900,
          color: '#1A2B3C',
          margin: 0,
          fontStyle: 'italic',
          letterSpacing: '-0.02em'
        }} data-id="element-330">
              Recently Used
            </h3>
          </div>
          <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(4, 1fr)',
        gap: 10
      }} data-id="element-331">
            {recent.map(tool => {
          const Icon = tool.icon;
          return <button key={tool.id} style={{
            display: 'flex',
            alignItems: 'center',
            gap: 10,
            padding: '10px 12px',
            borderRadius: 8,
            background: '#F4F8FC',
            border: '1px solid #E4EAF6',
            cursor: 'pointer',
            transition: 'all 0.15s',
            textAlign: 'left',
            borderLeft: '3px solid transparent'
          }} onMouseEnter={e => {
            e.currentTarget.style.borderLeftColor = '#2B8DC4';
            e.currentTarget.style.background = 'rgba(43,141,196,0.05)';
          }} onMouseLeave={e => {
            e.currentTarget.style.borderLeftColor = 'transparent';
            e.currentTarget.style.background = '#F4F8FC';
          }} data-id="element-332">
                  <div style={{
              width: 30,
              height: 30,
              borderRadius: 7,
              background: 'rgba(43,141,196,0.1)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              flexShrink: 0
            }} data-id="element-333">
                    <Icon size={15} color="#2B8DC4" strokeWidth={2} data-id="element-334" />
                  </div>
                  <span style={{
              fontSize: 12,
              fontWeight: 700,
              color: '#1A2B3C'
            }} data-id="element-335">
                    {tool.name}
                  </span>
                </button>;
        })}
          </div>
        </div>}

      {/* Category Filters */}
      <div style={{
      display: 'flex',
      gap: 8,
      flexWrap: 'wrap',
      marginBottom: 20
    }} data-id="element-336">
        {categories.map(cat => <button key={cat} onClick={() => setActiveCategory(cat)} style={{
        padding: '6px 14px',
        borderRadius: 6,
        fontSize: 12,
        fontWeight: 800,
        fontStyle: 'italic',
        cursor: 'pointer',
        border: 'none',
        transition: 'all 0.15s',
        background: activeCategory === cat ? '#2B8DC4' : '#FFFFFF',
        color: activeCategory === cat ? '#FFFFFF' : '#5A6A8A',
        boxShadow: activeCategory === cat ? '0 2px 8px rgba(43,141,196,0.3)' : '0 1px 3px rgba(13,27,42,0.08)'
      }} data-id="element-337">
            {cat}
          </button>)}
      </div>

      {/* Pinned Tools */}
      {pinned.length > 0 && <div style={{
      marginBottom: 24
    }} data-id="element-338">
          <div style={{
        display: 'flex',
        alignItems: 'center',
        gap: 6,
        marginBottom: 12
      }} data-id="element-339">
            <StarIcon size={13} color="#2B8DC4" data-id="element-340" />
            <span style={{
          fontSize: 11,
          fontWeight: 800,
          color: '#5A6A8A',
          textTransform: 'uppercase',
          letterSpacing: '0.08em'
        }} data-id="element-341">
              Pinned
            </span>
          </div>
          <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(4, 1fr)',
        gap: 12
      }} data-id="element-342">
            {pinned.map(tool => <ToolCard key={tool.id} tool={tool} highlighted data-id="element-343" />)}
          </div>
        </div>}

      {/* All Tools */}
      {unpinned.length > 0 && <div data-id="element-344">
          <div style={{
        display: 'flex',
        alignItems: 'center',
        gap: 6,
        marginBottom: 12
      }} data-id="element-345">
            <span style={{
          fontSize: 11,
          fontWeight: 800,
          color: '#5A6A8A',
          textTransform: 'uppercase',
          letterSpacing: '0.08em'
        }} data-id="element-346">
              All Tools
            </span>
          </div>
          <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(4, 1fr)',
        gap: 12
      }} data-id="element-347">
            {unpinned.map(tool => <ToolCard key={tool.id} tool={tool} highlighted={false} data-id="element-348" />)}
          </div>
        </div>}

      {filtered.length === 0 && <div style={{
      textAlign: 'center',
      padding: '48px 0'
    }} data-id="element-349">
          <RocketIcon size={44} color="#C8D8E8" style={{
        marginBottom: 12
      }} data-id="element-350" />
          <p style={{
        fontWeight: 700,
        color: '#5A6A8A',
        margin: '0 0 4px'
      }} data-id="element-351">
            No tools found
          </p>
          <p style={{
        fontSize: 13,
        color: '#A0AECB',
        margin: 0
      }} data-id="element-352">
            Try adjusting your search or filter
          </p>
        </div>}
    </div>;
}
function ToolCard({
  tool,
  highlighted
}: {
  tool: Tool;
  highlighted: boolean;
}) {
  const Icon = tool.icon;
  return <div style={{
    background: '#FFFFFF',
    borderRadius: 12,
    padding: '18px 18px',
    border: '1px solid #E4EAF6',
    borderTopWidth: 3,
    borderTopColor: highlighted ? '#2B8DC4' : '#1A2B3C',
    boxShadow: '0 2px 8px rgba(13,27,42,0.06)',
    cursor: 'pointer',
    transition: 'all 0.15s',
    position: 'relative'
  }} onMouseEnter={e => {
    ;
    (e.currentTarget as HTMLDivElement).style.boxShadow = '0 4px 16px rgba(43,141,196,0.15)';
    (e.currentTarget as HTMLDivElement).style.transform = 'translateY(-2px)';
  }} onMouseLeave={e => {
    ;
    (e.currentTarget as HTMLDivElement).style.boxShadow = '0 2px 8px rgba(13,27,42,0.06)';
    (e.currentTarget as HTMLDivElement).style.transform = 'translateY(0)';
  }} data-id="element-353">
      {tool.new && <span style={{
      position: 'absolute',
      top: 12,
      right: 12,
      fontSize: 9,
      fontWeight: 800,
      padding: '2px 6px',
      borderRadius: 3,
      background: '#EBF5FB',
      color: '#2B8DC4',
      letterSpacing: '0.06em'
    }} data-id="element-354">
          NEW
        </span>}
      <div style={{
      display: 'flex',
      alignItems: 'center',
      gap: 12,
      marginBottom: 10
    }} data-id="element-355">
        <div style={{
        width: 40,
        height: 40,
        borderRadius: 10,
        background: 'rgba(43,141,196,0.1)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0
      }} data-id="element-356">
          <Icon size={20} color="#2B8DC4" strokeWidth={1.8} data-id="element-357" />
        </div>
        <div data-id="element-358">
          <div style={{
          fontSize: 13,
          fontWeight: 900,
          color: '#1A2B3C',
          fontStyle: 'italic',
          letterSpacing: '-0.01em'
        }} data-id="element-359">
            {tool.name}
          </div>
          <div style={{
          fontSize: 10,
          fontWeight: 700,
          color: '#2B8DC4',
          background: '#EBF5FB',
          padding: '1px 6px',
          borderRadius: 3,
          display: 'inline-block',
          marginTop: 2
        }} data-id="element-360">
            {tool.category}
          </div>
        </div>
      </div>
      <p style={{
      fontSize: 12,
      color: '#5A6A8A',
      margin: '0 0 12px',
      lineHeight: 1.5
    }} data-id="element-361">
        {tool.description}
      </p>
      <div style={{
      display: 'flex',
      alignItems: 'center',
      gap: 4,
      fontSize: 11,
      fontWeight: 700,
      color: '#2B8DC4'
    }} data-id="element-362">
        <ExternalLinkIcon size={11} data-id="element-363" /> Open Tool
      </div>
    </div>;
}